export default __webpack_public_path__ + "static/media/sounds/TRO_Instructions_For_Questions.mp3";